
<nb-layout>
  <nb-layout-column>
    <ng-container *ngIf="!stellantisPageRouteActive && !isLogin">
    <ng-sidebar-container>
      <ng-sidebar
        [opened]="menuOpen"
        fxShow.gt-sm="false"
        [animate]="true"
        [closeOnClickBackdrop]="true"
        [showBackdrop]="true"
        [position]="'right'"
        (onClosed)="menuOpen=false"
        [mode]="'over'">
        <div class="mobile-menu-container" style="background: rgb(20 84 171);padding: 1em" fxFlex *ngIf="user$|async as user">
          <app-site-menu [user]="user" [mobile]="true" (onClose)="menuOpen=false;" (onLogout)="logout($event)"></app-site-menu>
        </div>

      </ng-sidebar>
      <div class="app-wrapper" ng-sidebar-content fxFlexFill ngxUiLoaderBlurred fxLayout="row">
        <div class="app-container" fxLayout="column" fxFlex="100">
          <ng-container *ngIf="user$|async as user">
            <div class="header-wrapper" fxLayout="column" fxFlex="0 1 auto">
              <div class="header-container" style="padding-top: 0; width: 100%;" fxLayout="row" fxLayoutAlign=""
                   fxLayoutAlign.lt-md="stretch">
                <app-header [user]="user$|async" fxFlex="87vw" fxFlex.lt-md=""
                            (onMenuClicked)="menuClicked($event)"></app-header>
              </div>
            </div>
            <div class="app-content-wrapper" fxFlex="" fxLayout="column">
              <div class="app-content-container" fxFlex="">
                <router-outlet></router-outlet>
              </div>
            </div>
            <div class="app-footer-wrapper" fxFlex.lt-md="0 0 0" fxFlex="0 0 15">
              <app-footer fxFlexFill></app-footer>
            </div>
            <ngx-bottom-nav fxShow.xs="true" fxHide="true" *ngIf="!isUAERoute">
              <button  ngx-bottom-nav class="new-order-button"  label="{{ 'BOTTOM_NAV.NEW_ORDER' | translate }}" routerLink="/account/calculate" *ngIf="user.isLogin">
                <mat-icon ngxBottomNavIcon >note_add</mat-icon>
              </button>
              <button ngx-bottom-nav label="{{ 'BOTTOM_NAV.MY_ACCOUNT' | translate }}" routerLink="/account" *ngIf="user.isLogin">
                <mat-icon ngxBottomNavIcon>person</mat-icon>
              </button>
              <button ngx-bottom-nav label="{{ 'BOTTOM_NAV.REGISTER_LOGIN' | translate }}" routerLink="/auth/login" *ngIf="!user.isLogin" (click)="openDialog()">
                <mat-icon ngxBottomNavIcon>person</mat-icon>
              </button>
              <button ngx-bottom-nav *ngIf="contactMethod==='mail'" (click)="navigateMail()">
                <mat-icon ngxBottomNavIcon svgIcon="fi_email"></mat-icon>
              </button>
              <button ngx-bottom-nav *ngIf="contactMethod==='wa'" label="{{ 'BOTTOM_NAV.CONTACT_US' | translate }}" (click)="navigateWa()">
                <mat-icon ngxBottomNavIcon svgIcon="fi_whatsapp"></mat-icon>
              </button>
            </ngx-bottom-nav>
            <ngx-bottom-nav fxShow.xs="true" fxHide="true" *ngIf="isUAERoute">
              <button  ngx-bottom-nav class="new-order-button"  label="New Order" routerLink="/account/calculate" *ngIf="user.isLogin">
                <mat-icon ngxBottomNavIcon >note_add</mat-icon>
              </button>
              <button ngx-bottom-nav label="My Profile" routerLink="/account" *ngIf="user.isLogin">
                <mat-icon ngxBottomNavIcon>person</mat-icon>
              </button>
              <button ngx-bottom-nav label="Register / Login" routerLink="/auth/login" *ngIf="!user.isLogin && !isUAERoute" (click)="openDialog()">
                <mat-icon ngxBottomNavIcon>person</mat-icon>
              </button>
              <button ngx-bottom-nav *ngIf="contactMethod==='mail'" (click)="navigateMail()">
                <mat-icon ngxBottomNavIcon svgIcon="fi_email"></mat-icon>
              </button>
              <button ngx-bottom-nav *ngIf="contactMethod==='wa'" label="Contact Us" (click)="navigateWa()">
                <mat-icon ngxBottomNavIcon svgIcon="fi_whatsapp"></mat-icon>
              </button>
            </ngx-bottom-nav>
          </ng-container>
        </div>

        <div class="contact-us-area" fxShow.lt-md="false" *ngIf="false">
          <app-contact-us-button></app-contact-us-button>
        </div>
      </div>
    </ng-sidebar-container>
    </ng-container>
    <div class="app-content-wrapper" fxFlex="" fxLayout="column" *ngIf="stellantisPageRouteActive">
      <div class="app-content-container" fxFlex="">
        <router-outlet></router-outlet>
      </div>
    </div>

    <ng-container *ngIf="isLogin">
      <div class="app-wrapper" fxFlexFill>
        <router-outlet></router-outlet>
      </div>
    </ng-container>

  </nb-layout-column>
</nb-layout>


<ngx-ui-loader></ngx-ui-loader>

